export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  return cleaned;
};

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';

export const SERVER_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm A';

export const UI_TIME_FORMAT = 'hh:mm A';

export const UI_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const EMAIL_REGEX = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
